import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-action-sheet.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlActionSheet = /*@__PURE__*/ createInlineOverlayComponent<JSX.FmlActionSheet, HTMLFmlActionSheetElement>(
  'fml-action-sheet',
  defineCustomElement
);
